import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import {Title,Meta} from '@angular/platform-browser';

@Component({selector: 'NovedadesComponent', 
  templateUrl: './novedades.Component.html',
 styleUrls: ['./novedades.component.scss']})
export class NovedadesComponent implements OnInit {
    currentJustify = 'justified';
     panelOpenState = false;

public Titulo;
public Descripcion;
public Img;

public Titulos;
public Items;
public TitCol1;
public TitCol2;
public titleHead;
public metaHead;

	ngOnInit()
	{

   
  document.getElementById("port").hidden = false;
   //this.sec = window.location.pathname;
  document.getElementById("portContac").hidden = true;
  window.scroll(0, 0);
   //document.body.scrollTop=0;

   
	}

cotizar()
{
   this.router.navigate(['/contactos']);
}

  
portada()
      {
          this.router.navigate(['/']);
      }
	
  constructor(private authService: AuthService, private router: Router,private title:Title, private meta: Meta){}
}


